import { render, staticRenderFns } from "./ContactListZalo.vue?vue&type=template&id=0524b898&scoped=true"
import script from "./ContactListZalo.vue?vue&type=script&lang=js"
export * from "./ContactListZalo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524b898",
  null
  
)

export default component.exports